import {
  accountIdFormat,
  processingGroupIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const setProcessingGroupMerchants = {
  name: "setProcessingGroupMerchants" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    merchantAccountIds: z.array(accountIdFormat.schema),
  }),
  output: z.null(),
};
